import React from 'react';
import Highlight, { defaultProps, Language } from 'prism-react-renderer';
import cx from 'classnames';

import CodeBlock, { Props as CodeBlockProps } from '../CodeBlock';
import styles from '../CodeBlock/CodeBlock.module.scss';

import theme from './CodeBlockHighlighted.styles';

export interface Props extends CodeBlockProps {
  code: string;
  lang: Language | 'ruby' | 'java';
  preChildren?: React.ReactNode;
  showLineStart?: number;
  showLineEnd?: number;
}

export const CodeBlockHighlighted: React.FC<Props> = ({
  code,
  showLineStart,
  showLineEnd,
  lang,
  wrap,
  preChildren,
  ...restProps
}) => {
  const shouldShowLine = (i: number) => {
    if (showLineStart == null || showLineEnd == null) return true;
    if (i >= showLineStart && i <= showLineEnd) {
      return true;
    }
    return false;
  };

  return (
    <CodeBlock code={null} {...restProps} showLineStart={showLineStart}>
      <Highlight
        {...defaultProps}
        theme={theme}
        code={code}
        language={
          // temporary hack, see https://github.com/FormidableLabs/prism-react-renderer/pull/64
          lang === 'ruby' ? 'python' : lang === 'java' ? 'typescript' : lang
        }
        children={({
          className,
          style,
          tokens,
          getLineProps,
          getTokenProps,
        }) => (
          <div className={styles.container}>
            <pre
              className={cx(
                styles.pre,
                wrap ? styles.wrap : styles.noWrap,
                className,
              )}
              style={style}
            >
              <div className={cx(styles.code)}>
                {tokens.map((line, i) => (
                  <div
                    {...getLineProps({ line, key: i })}
                    className={cx(
                      styles.line,
                      !shouldShowLine(i) && styles.fadedLine,
                    )}
                  >
                    <span className={styles.lineNumbers}>{i + 1}</span>
                    {line.map((token, key) => (
                      <span {...getTokenProps({ token, key })} />
                    ))}
                  </div>
                ))}
              </div>
              {preChildren}
            </pre>
          </div>
        )}
      />
    </CodeBlock>
  );
};

CodeBlockHighlighted.displayName = 'CodeBlockHighlighted';
export default CodeBlockHighlighted;
export { styles };
